export default __webpack_public_path__ + "static/media/t-shirts.3d88c3d1.svg";